/* tslint:disable */
/* eslint-disable */
/**
 * Guarantees API
 * Référentiel des garanties, rattachées aux branches
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RolePrimeDerivee } from './RolePrimeDerivee';
import {
    RolePrimeDeriveeFromJSON,
    RolePrimeDeriveeFromJSONTyped,
    RolePrimeDeriveeToJSON,
    RolePrimeDeriveeToJSONTyped,
} from './RolePrimeDerivee';

/**
 * Modification d'une garantie du référentiel. `branchId` accepte null, ce qui permet aussi de rattacher à une branche une garantie qui n'en avait pas.
 * @export
 * @interface UpdateGarantieReferentielCommand
 */
export interface UpdateGarantieReferentielCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateGarantieReferentielCommand
     */
    branchId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateGarantieReferentielCommand
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGarantieReferentielCommand
     */
    shortLabel: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateGarantieReferentielCommand
     */
    label: string;
    /**
     * 
     * @type {RolePrimeDerivee}
     * @memberof UpdateGarantieReferentielCommand
     */
    derivedPremiumRole?: RolePrimeDerivee;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateGarantieReferentielCommand
     */
    damage?: boolean;
}



/**
 * Check if a given object implements the UpdateGarantieReferentielCommand interface.
 */
export function instanceOfUpdateGarantieReferentielCommand(value: object): value is UpdateGarantieReferentielCommand {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('shortLabel' in value) || value['shortLabel'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function UpdateGarantieReferentielCommandFromJSON(json: any): UpdateGarantieReferentielCommand {
    return UpdateGarantieReferentielCommandFromJSONTyped(json, false);
}

export function UpdateGarantieReferentielCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGarantieReferentielCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'code': json['code'],
        'shortLabel': json['shortLabel'],
        'label': json['label'],
        'derivedPremiumRole': json['derivedPremiumRole'] == null ? undefined : RolePrimeDeriveeFromJSON(json['derivedPremiumRole']),
        'damage': json['damage'] == null ? undefined : json['damage'],
    };
}

export function UpdateGarantieReferentielCommandToJSON(json: any): UpdateGarantieReferentielCommand {
    return UpdateGarantieReferentielCommandToJSONTyped(json, false);
}

export function UpdateGarantieReferentielCommandToJSONTyped(value?: UpdateGarantieReferentielCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'branchId': value['branchId'],
        'code': value['code'],
        'shortLabel': value['shortLabel'],
        'label': value['label'],
        'derivedPremiumRole': RolePrimeDeriveeToJSON(value['derivedPremiumRole']),
        'damage': value['damage'],
    };
}

